export var aspectRatio = '_23395';
export var entrepreneur = '_1ziCl';
export var outlines = {blue:'_250Qz',yellow:'_368B7',green:'_1vhIq',purple:'_2tLdl'};
export var portrait = '_3fqsa';
export var portraitOverrides = {bob:'_2Z38H',kevin:'_3SmZN',sig:'_2Znp3'};